import script from "./Skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./Skeleton.vue?vue&type=script&setup=true&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=6ffff7ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffff7ba"]])

export default __exports__